/**
 * Asset: Multi-store config
 * ------------------------------------------------------------------------------
 * Configuration file used in `redirect.js` and `currency.js` handler.
 * - All properties are required, leave empty string if unused.
 */
window.Frame = window.Frame || {};
window.Frame.MultiStore = [
  {
    storeCode: 'EU',
    storeName: 'Europe',
    storeUrl: 'https://eu.dbjourney.com/',
    supportedLanguages: 'EN',
    supportedCurrencies: 'EUR',
    supportedStores: 'XK,MD,ME,JE,IM,RS,GL,AD,AL,AM,AT,AX,BA,BE,BG,BY,CH,CY,CZ,DK,DE,EE,ES,FI,FO,FR,GE,GI,GR,HR,HU,IE,IS,IT,LT,LU,LV,MC,MK,MT,NL,PL,PT,RO,SI,SK,SM,UA,VA',
  },
  {
    storeCode: 'UK',
    storeName: 'United Kingdom',
    storeUrl: 'https://uk.dbjourney.com/',
    supportedLanguages: 'EN',
    supportedCurrencies: 'GBP',
    supportedStores: 'GB-ENG,GB-NIR,GB-SCT,GB-WLS',
  },
  {
    storeCode: 'US',
    storeName: 'United States',
    storeUrl: 'https://us.dbjourney.com/',
    supportedLanguages: 'EN, FR',
    supportedCurrencies: 'USD',
    supportedStores: 'UM,CA,US,AE,AF,AG,AI,AM,AO,AQ,AR,AS,AW,AZ,BB,BD,BF,BH,BI,BJ,BM,BN,BO,BQ,BR,BS,BT,BW,BZ,CF,CG,CI,CL,CM,CN,CO,CR,CU,CV,DJ,DM,DO,DZ,EC,EG,EH,ER,ET,FK,GA,GD,GD,GE,GF,GH,GM,GN,GP,GQ,GT,GW,GY,HK,HN,HT,ID,IL,IN,IO,IQ,IR,JM,JO,JP,KE,KG,KH,KM,KR,KW,KY,KZ,LA,LB,LK,LR,LS,LY,MA,MG,ML,MM,MN,MO,MQ,MR,MS,MU,MV,MW,MX,MY,MZ,NA,NE,NG,NI,NP,OM,PA,PE,PG,PH,PK,PR,PY,QA,RU,RW,SA,SC,SD,SG,SL,SN,SO,SR,ST,SV,SX,SY,SZ,TD,TG,TH,TJ,TM,TN,TR,TT,TW,TZ,UG,UY,UZ,VE,VG,VI,VN,YE,ZA,ZM,ZW,CK,FJ,FM,KI,MH,NA,NU,PW,SB,TO,TV,VU,WS,BV,CX,CC,CD,CW,PF,TF,GU,GG,HM,KP,LI,YT,NR,NC,NF,MP,PS,PN,RE,BL,SH,KN,LC,MF,PM,VC,GS,SS,SJ,TL,TK,TC,WF',
  },
  {
    storeCode: 'NO',
    storeName: 'Norway',
    storeUrl: 'https://dbjourney.com/',
    supportedLanguages: 'NO',
    supportedCurrencies: 'NOK',
    supportedStores: '',
  },
  {
    storeCode: 'SE',
    storeName: 'Sweden',
    storeUrl: 'https://se.dbjourney.com/',
    supportedLanguages: 'SE',
    supportedCurrencies: 'SEK',
    supportedStores: '',
  },
];
